import { MapTo } from '@adobe/aem-react-editable-components';
import ImageList, { ImageListEditConfig } from './ImageList';

export default MapTo('cob-corp-acquisition/components/creditonebank/image-list')(ImageList, ImageListEditConfig);